'use client';

import { c as _c } from "react/compiler-runtime";
import { createPortal } from 'react-dom';
import { cloneElement, useCallback } from 'react';
import { usePopperTooltip } from 'react-popper-tooltip';
import classNames from '@/utils/classNames';
import type { Config } from 'react-popper-tooltip';
export interface TooltipProps extends Config {
  children: React.ReactElement<{
    ref?: React.Ref<unknown>;
  }>;
  content: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  disabled?: boolean;
  withArrow?: boolean;
}
const assignRef = (ref: React.Ref<unknown> | undefined, node: unknown) => {
  if (!ref) return;
  if (typeof ref === 'function') {
    ref(node);
  } else {
    (ref as React.MutableRefObject<unknown>).current = node;
  }
};
const Tooltip = t0 => {
  const $ = _c(20);
  let children;
  let className;
  let content;
  let disabled;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children,
      content,
      className,
      style: t1,
      disabled,
      delayShow: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = content;
    $[4] = disabled;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    children = $[1];
    className = $[2];
    content = $[3];
    disabled = $[4];
    props = $[5];
    t1 = $[6];
    t2 = $[7];
  }
  const style = t1 === undefined ? {} : t1;
  const delayShow = t2 === undefined ? 150 : t2;
  let t3;
  if ($[8] !== delayShow || $[9] !== props) {
    t3 = {
      ...props,
      delayShow
    };
    $[8] = delayShow;
    $[9] = props;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const {
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible
  } = usePopperTooltip(t3);
  const childRef = children.props?.ref;
  let t4;
  if ($[11] !== childRef || $[12] !== setTriggerRef) {
    t4 = node => {
      setTriggerRef(node);
      assignRef(childRef, node);
    };
    $[11] = childRef;
    $[12] = setTriggerRef;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const setMergedTriggerRef = t4;
  if (!content || disabled) {
    return children;
  }
  let t5;
  if ($[14] !== children || $[15] !== setMergedTriggerRef) {
    t5 = cloneElement(children, {
      ref: setMergedTriggerRef
    });
    $[14] = children;
    $[15] = setMergedTriggerRef;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const t6 = visible && createPortal(<div ref={setTooltipRef} {...getTooltipProps({
    style: {
      zIndex: "var(--z-index-tooltip)",
      ...style
    },
    className: classNames("flex max-w-xs items-center justify-center gap-2 rounded-sm bg-greyscale-900 px-2 py-1.5 whitespace-nowrap text-white shadow-md first-letter:capitalize", "data-[popper-reference-hidden=\"true\"]:pointer-events-none data-[popper-reference-hidden=\"true\"]:invisible", className)
  })}>{content}</div>, document?.body);
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export default Tooltip;